module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-left-fill-772e4e60.svg";